module.exports = "<nav role=\"navigation\" class=\"navbar\">\n  <div class=\"nav-wrapper container\">\n    <a id=\"logo-container\" href=\"#\" class=\"brand-logo\">\n      <img src=\"assets/images/cage.png\" alt=\"Nic Cage\" />\n    </a>\n    <ul class=\"nav-link\">\n      <li ng-repeat=\"link in $ctrl.links\">\n        <a href=\"\" ui-sref=\"{{link.component}}\">{{link.name}}</a>\n      </li>\n    </ul>\n  </div>\n</nav>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/shared/navbar/navbar.html
 ** module id = 51
 ** module chunks = 0
 **/